import { Main } from '@components/Main';
import { PageContent } from '@components/PageContent';
import { PageTitle, PageTitleText } from '@components/PageTitle';
import { useData } from '@hooks/useData';
import { useEffectOnce } from '@hooks/useEffectOnce';
import { useField } from '@hooks/useField';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { EnumSortDirection } from '@hooks/useRequest';
import { EnumContratoClienteStatus, useContratoClienteStatusCombo } from '@model/ContratoClienteStatus';
import { EnumEmpresa, useEmpresaCombo } from '@model/Empresa';
import { EnumOperadora, useOperadoraCombo } from '@model/Operadora';
import { IRelatorioValorFranquiaPlanosFilter, IRelatorioValorFranquiaPlanosRecord, useRelatorioValorFranquiaPlanosService } from '@services/Relatorios/ValorFranquiaPlanos';
import React from 'react';
import { RelatorioValorFranquiaPlanosFilter } from './Filter';
import { RelatorioValorFranquiaPlanosTable } from './Table';

export type RelatorioValorFranquiaPlanosProps = {
}

export function RelatorioValorFranquiaPlanos (props: RelatorioValorFranquiaPlanosProps) {
    const data = useData<IRelatorioValorFranquiaPlanosRecord, IRelatorioValorFranquiaPlanosFilter>({
        filter: {
            empresaId: useField(EnumEmpresa.None),
            operadoraId: useField(EnumOperadora.None),
            contratoClienteStatusId: useField(EnumContratoClienteStatus.Ativo),
            valorPlanoDe: useField(),
            valorPlanoAte: useField(),
            franquiaGbDe: useField(),
            franquiaGbAte: useField()
        },

        sortField: {
            name: "linhaContratoOperadoraEmpresaNome",
            direction: EnumSortDirection.Asc
        }
    })

    const loading = useLoading();
    const message = useMessage();

    const relatorioValorFranquiaPlanosService = useRelatorioValorFranquiaPlanosService();

    const empresaCombo = useEmpresaCombo();
    const operadoraCombo = useOperadoraCombo();
    const contratoClienteStatusCombo = useContratoClienteStatusCombo();

    const handleCsvButtonClick = React.useCallback(() => {
        if (!loading.isLoading) {
            loading.start();
            relatorioValorFranquiaPlanosService.exportar(data.requestedData)
                .catch(message.showBlobException)
                .finally(loading.stop);

        }
    }, [data.requestedData, loading, message.showBlobException, relatorioValorFranquiaPlanosService]);

    React.useEffect(() => {
        if (!loading.isLoading) {
            loading.start();
            relatorioValorFranquiaPlanosService.listar(data.requestedData)
                .then(data.handleResultResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.requestedData]);

    useEffectOnce(() => {
        empresaCombo.loadOptions();
        operadoraCombo.loadOptions();
        contratoClienteStatusCombo.loadOptions();
    });

    return (
        <React.Fragment>
            <Main>
                <PageTitle>
                    <PageTitleText text="Relatório de Valor e Franquia de Planos" />
                </PageTitle>

                <PageContent>
                    <RelatorioValorFranquiaPlanosFilter
                        filter={data.filter}
                        isLoading={loading.isLoading}
                        empresaCombo={empresaCombo}
                        operadoraCombo={operadoraCombo}
                        contratoClienteStatusCombo={contratoClienteStatusCombo}
                    />
                    
                    <RelatorioValorFranquiaPlanosTable 
                        data={data}
                        isLoading={loading.isLoading}
                        onCsvButtonClick={handleCsvButtonClick}
                    />
                </PageContent>
            </Main>
        </React.Fragment>
    )
}